export default class Accordion {
  constructor() {
    this.bind()
    this.checkAccordionBlockControlButton()
  }

  bind() {
    $(".accordion__btn").click(function (e) {
      $(this).toggleClass("accordion__btn--open")
      $(this).closest(".accordion").find(".accordion__body").slideToggle()
      $(this).blur()
    })
  }

  checkAccordionBlockControlButton() {
    $(".accordion-block").each(function () {
      const $accordionBlock = $(this)
      const $accordions = $accordionBlock.find(".accordion-block__accordion")
      const $controlButton = $accordionBlock.find(".accordion-block__control-button")
      const $plusIcon = $controlButton.find(".mdi-plus")
      const $minusIcon = $controlButton.find(".mdi-minus")

      const checkAccordions = () => {
        const total = $accordions.length;
        const openCount = $accordions.filter(
          (_, el) => $(el).find("h3").attr("aria-expanded") === "true"
        ).length;
        const closedCount = total - openCount;

        $plusIcon.toggle(closedCount > 0);
        $minusIcon.toggle(openCount > 0);

        if (openCount === total) {
          $controlButton.find("span").text("Collapse All");
        } else {
          $controlButton.find("span").text("Expand All");
        }
      }

      // Initial check
      checkAccordions()

      // Check on click
      $controlButton.click(() => {
        // setTimeout to ensure the state is updated
        setTimeout(checkAccordions, 0)
      })
    })
  }
}
